import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { kayshOperator } from '@karacas/kaysh';
import { _logTap } from '@shared/aux_helper_environment';
import { _get, _ms } from '@shared/aux_helper_functions';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { IFilter } from './generic-tags-select-filtered.component';

export interface FilteredTagsResponse {
  visibleTagsRoots: { id: number; isRequired?: boolean }[];
  filteredTagValueIds: number[];
}

@Injectable({
  providedIn: 'root',
})
export class GenericTagsSelectFilteredService {
  private configBase = _get(environment, 'apiBaseUrl_spaces');
  private config = _get(environment, 'promotionV2.tags');
  private cancelationTokens: { [key: number]: Subject<void> } = {};
  private persistedFilters: { [context: string]: IFilter[] } = {};

  constructor(private http: HttpClient) {}

  getFilteredTags(filters, tagsModuleType: number): Observable<FilteredTagsResponse> {
    if (this.cancelationTokens[tagsModuleType]) {
      this.cancelationTokens[tagsModuleType].next();
      this.cancelationTokens[tagsModuleType].complete();
    }

    this.cancelationTokens[tagsModuleType] = new Subject<void>();

    const _url = `${this.configBase}${this.config.api.resources.filteredAttributesByTags}/${tagsModuleType}`;
    return this.http.post<FilteredTagsResponse>(_url, filters).pipe(
      takeUntil(this.cancelationTokens[tagsModuleType]),
      tap(data => _logTap(`${GenericTagsSelectFilteredService.name}::getFilteredTags (tap)`, data)),
      kayshOperator(`getFilteredTags_${tagsModuleType}`, filters, { localStorage: false, maxTime: _ms('10m') })
    );
  }

  updateFilters(context: string, filters: IFilter[]): void {
    this.persistedFilters[context] = filters || [];
  }

  getFilters(context: string): IFilter[] {
    return [...(this.persistedFilters[context] || [])];
  }

  clearFilters(context: string): void {
    this.persistedFilters[context] = [];
  }
}
